export default __webpack_public_path__ + "static/media/inele.75a17177.png";